import { useEffect, useRef, useState } from "react";
import styles from "./category-selector.module.css";
import { useTranslations } from "next-intl";
import { MdErrorOutline } from "react-icons/md";
import { KeyboardArrowDown } from "@mui/icons-material";
import {
  ApartmentCategoryEnum,
  HouseCategoryEnum,
  LandCategoryEnum,
  OfficeCategoryEnum,
  TypeEnum,
} from "@/types/types";
import { getCategoryOptions } from "@/lib/getCategories/getCategoryOptins";

export default function CategorySelector({
  activeValue,
  categoryError,
  type,
  onClick,
}: {
  activeValue?:
    | ApartmentCategoryEnum
    | HouseCategoryEnum
    | LandCategoryEnum
    | OfficeCategoryEnum
    | null;
  categoryError?: string;
  type: TypeEnum;
  onClick: (
    newValue:
      | ApartmentCategoryEnum
      | HouseCategoryEnum
      | LandCategoryEnum
      | OfficeCategoryEnum
  ) => void;
}) {
  const t = useTranslations("NewListing.Category");
  const currentYear = new Date().getFullYear();
  const [isActive, setIsActive] = useState(false);
  const toggleRef = useRef<HTMLDivElement | null>(null);
  const categoryOptions = getCategoryOptions(type);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };
    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  return (
    <div id="category" className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${categoryError && styles.error}`}>
        {t("categoryTitle")}*
      </h3>
      {categoryError && (
        <p className={styles.errorText}>
          {t(categoryError)}
          <span>
            <MdErrorOutline />
          </span>
        </p>
      )}
      <div className={styles.selectorWrapper} ref={toggleRef}>
        <button
          className={`${styles.pickerWrapper} ${categoryError && styles.error}`}
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <span className={styles.selected}>
            {activeValue ? `${t(activeValue)}` : t("pick")}
          </span>
          <KeyboardArrowDown />
        </button>
        {isActive && (
          <div className={styles.selection}>
            {categoryOptions.map((option, index) => {
              return (
                <button
                  className={styles.selectionWrapper}
                  key={option}
                  onClick={(e) => {
                    e.preventDefault();
                    onClick(option);
                    setIsActive(false);
                  }}
                >
                  <span>{t(option)}</span>
                  <div className={styles.separator}></div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
